'use strict';

/**
 * Component for the species seleciton
 *
 * @category   View
 * @module     collectio.edit
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ItemView = require('base/Colido.ItemView');
var Awesomplete = require('vendor/awesomplete');

var template = require('../../templates/components/field-species-list-item.hbs');

var SpeciesSelectionListItemView = ItemView.extend({
    template: template,

    wrapItem: false,

    ui: {
        'container': '.species-container',
        'speciesField': '.material-addition input',
        'correlationContainer': '.correlation-container',
        'correlationOptions': '.correlation-container input',
        'morphContainer': '.correlation-container-morph',
        'morphOptions': '.correlation-container-morph input',
    },

    events: {
        'change @ui.correlationOptions': 'onCorrelationChange',
        'change @ui.morphOptions': 'onCorrelationChange',
        'input @ui.speciesField': 'onInputSpeciesField',
        'awesomplete-selectcomplete @ui.speciesField': 'onAwesompleteSelectComplete',
    },

    modelEvents: {
        'change:correlation': 'onModelCorrelationChange',
        'change:active': 'onModelActiveChange',
    },

    /**
     * Reference to awesomplete
     * @type {Awesomplete}
     */
    awesomplete: null,

    /**
     * Internal cache
     * @type {Object}
     */
    awesompleteCache: {},

    /**
     * Is triggered from the model, when the correlation has been changed
     */
    onModelCorrelationChange: function() {
        this.checkMorphActive();
    },

    /**
     * Is triggered from the model, when the active state has been changed
     * @type {Colido.Model} model The model, that was changed
     * @type {boolean}      value The new state for active
     */
    onModelActiveChange: function(model, value) {
        this.ui.container.toggleClass('is-active', value);
    },

    /**
     * Is triggered from the option select, when a new option has been selected
     */
    onSpeciesChange: function() {
        this.model.set('name', this.ui.speciesField.val());
    },

    /**
     * Is triggered from the morph select, when a new option has been selected
     */
    onCorrelationChange: function() {
        var correlation = this.ui.correlationOptions.filter(':checked').val();
        var morph = this.ui.morphOptions.filter(':checked').val();
        var value = correlation === 'after' ? morph : correlation;

        this.model.set('correlation', value);
    },

    /**
     * Checks, if the morph correlation should be displayed
     */
    checkMorphActive: function() {
        var isAfter = this.ui.correlationOptions.filter(':checked').val() === 'after';
        this.ui.morphContainer.toggleClass('is-active', isAfter);
    },

    onAttach: function() {
        // Init awesomplete
        this.awesomplete = new Awesomplete(this.ui.speciesField[0], {
            minChars: 1,
            maxItems: 6,
            list: [],
        });
    },

    /**
     * Is triggered, when the user inputs something into the species field
     * @param {object} event The input event
     */
    onInputSpeciesField: function(event) {
        // Get value
        var val = this.ui.speciesField.val();

        // Process response from api or cache
        if (this.awesompleteCache[val]) {
            this.processAutocompleteResponse(this.awesompleteCache[val]);
        } else {
            var request = $.getJSON(App.getApiUrl('/species/' + val));
            request.done(function(response) {
                this.awesompleteCache[val] = response;
                this.processAutocompleteResponse(response);
            }.bind(this));
        }

        // Set value into model
        this.model.set('name', this.ui.speciesField.val());
    },

    /**
     * Processes the response from API or cache
     * @param {object} response The response object, containing autocomplete items
     */
    processAutocompleteResponse: function(response) {
        if (this.awesomplete) {
            this.awesomplete.list = _.pluck(_.values(response), 'name');
            this.awesomplete.evaluate();
        }
    },

    /**
     * Is triggered, when the user selects a value from autocomplete
     * @param {object} event The select complete event from awesomplete
     */
    onAwesompleteSelectComplete: function(event) {
        this.model.set('name', this.ui.speciesField.val());
    },

    onBeforeDestroy: function() {
        this.ui.speciesField.off();
    },
});

module.exports = SpeciesSelectionListItemView;